import { render } from "./DefectTableSelect.vue?vue&type=template&id=37ae3858&scoped=true"
import script from "./DefectTableSelect.vue?vue&type=script&lang=js"
export * from "./DefectTableSelect.vue?vue&type=script&lang=js"

import "./DefectTableSelect.vue?vue&type=style&index=0&id=37ae3858&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ae3858"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QDialog,QCard,QBar,QSpace,QBtn,QTooltip,QCardSection,QBanner,QTable});
